<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Income information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap justify-content-end>
                  <v-flex xs6 sm6 class="pa-2">
                    <v-text-field
                      v-model="incomeInfo.amount"
                      :label="`${$t('Amount')} (${systemCurrency}) *`"
                      box
                      hide-details
                      background-color="white"
                      append-icon="fa-hand-holding-usd"
                      @click:append="isMultiCurrency = !isMultiCurrency"
                      :readonly="isMultiCurrency"
                      :error="errors.has('Amount')"
                      data-vv-name="Amount"
                      v-validate="'required|decimal:3|min_value:0'"
                      data-vv-delay="1000"
                    />
                  </v-flex>

                  <v-flex xs6 sm6 class="pa-2">
                    <v-menu v-model="paymentDateMenu" full-width max-width="290" :close-on-content-click="false">
                      <v-text-field
                        slot="activator"
                        :value="incomeInfo.payment_date"
                        :label="`${$t('Payment Date')} *`"
                        prepend-inner-icon="event"
                        box
                        readonly
                        hide-details
                        name="payment_date"
                        background-color="white"
                        autocomplete="off"
                        :error="errors.has('payment_date')"
                        v-validate="'required|date_format:yyyy-MM-dd'"
                      />
                      <v-date-picker @change="paymentDateMenu = false" v-model="incomeInfo.payment_date" />
                    </v-menu>
                  </v-flex>

                  <v-flex xs6 sm6 class="pa-2" v-if="isMultiCurrency">
                    <v-text-field
                      v-model="incomeInfo.amount_main"
                      :label="`${$t('Amount')} (${systemCurrency}) *`"
                      box
                      hide-details
                      background-color="white"
                      name="amount_main"
                      :error="errors.has('amount_main')"
                      v-validate="'required|decimal:3|min_value:0'"
                      @input="amountCalculation()"
                      data-vv-delay="1000"
                    />
                  </v-flex>

                  <v-flex xs6 sm6 pr-2 pl-2 pt-2 v-if="isMultiCurrency">
                    <v-text-field
                      v-model="incomeInfo.amount_secondary"
                      :label="`${$t('Amount')} (${systemCurrency === 'USD' ? $t('IQD') : $t('USD')}) *`"
                      box
                      :hint="`${$t('Dollar Rate')} : ${incomeInfo.dollar_rate}`"
                      persistent-hint
                      background-color="white"
                      name="amount_secondary"
                      :error="errors.has('amount_secondary')"
                      v-validate="'required|decimal:3|min_value:0'"
                      @input="amountCalculation()"
                      data-vv-delay="1000"
                    />
                  </v-flex>

                  <v-flex pa-2>
                    <v-autocomplete
                      :items="incomeTypesList"
                      v-model="incomeInfo.income_type_id_fk"
                      :label="`${$t('Income Type')}`"
                      box
                      hide-details
                      :error="errors.has('Income Type')"
                      background-color="white"
                      data-vv-name="Income Type"
                      :menu-props="{ transition: 'slide-y-transition' }"
                    />
                  </v-flex>

                  <v-flex xs1 pt-2 v-if="hasPermissions(['income_types_store'])">
                    <v-tooltip top>
                      <v-btn label @click="$emit('add-income-type')" slot="activator" icon fab small color="green">
                        <v-icon color="white" size="25">add</v-icon>
                      </v-btn>
                      <span>{{ $t('Add new incomes type') }}</span>
                    </v-tooltip>
                  </v-flex>

                  <v-flex xs6 sm6 class="pa-2">
                    <v-text-field
                      v-model="incomeInfo.place"
                      :label="$t('Address')"
                      box
                      name="place"
                      hide-details
                      background-color="white"
                    />
                  </v-flex>

                  <v-flex xs6 sm6 class="pa-2">
                    <v-text-field
                      v-model="incomeInfo.property_no"
                      :label="$t('Property Number')"
                      box
                      name="property_no"
                      hide-details
                      background-color="white"
                    />
                  </v-flex>

                  <v-flex xs6 sm6 class="pa-2">
                    <v-text-field
                      v-model="incomeInfo.contract_no"
                      :label="$t('Contract Number')"
                      box
                      name="contract_no"
                      hide-details
                      background-color="white"
                    />
                  </v-flex>

                  <v-flex xs6 sm6 class="pa-2">
                    <v-text-field
                      v-model="incomeInfo.contract_organizer"
                      :label="$t('Organizer')"
                      box
                      name="contract_organizer"
                      hide-details
                      background-color="white"
                    />
                  </v-flex>

                  <v-flex xs6 sm6 class="pa-2">
                    <v-text-field
                      v-model="incomeInfo.payer"
                      :label="$t('Payer Name')"
                      box
                      name="payer"
                      hide-details
                      background-color="white"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 class="pa-2">
                <v-textarea
                  v-model="incomeInfo.note"
                  :label="`${$t('Note')}`"
                  name="note"
                  hide-details
                  box
                  height="80"
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false,
      paymentDateMenu: false,
      isMultiCurrency: false
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      dollarRate: 'dollarRates/getLastDollarPrice',
      incomeInfo: 'incomes/getIncomeInfo',
      incomeTypesList: 'incomeTypes/getFullIncomeTypesList',
      staffsList: 'staff/getFullStaffsList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
          this.isMultiCurrency = this.incomeInfo.is_multi_currency === '1'
          if (this.incomeInfo.dollar_rate === undefined) {
            this.incomeInfo.dollar_rate = this.dollarRate
          }
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateIncomeInfo: 'incomes/updateIncomeInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    amountCalculation() {
      const exchangeSecondary =
        this.systemCurrency === 'USD'
          ? Number(this.incomeInfo.amount_secondary || 0) / this.incomeInfo.dollar_rate
          : Number(this.incomeInfo.amount_secondary || 0) * this.incomeInfo.dollar_rate
      this.incomeInfo.amount = (Number(this.incomeInfo.amount_main || 0) + exchangeSecondary).toFixed(2)
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true
          let formData = new FormData(event.target)
          formData.append('is_multi_currency', this.isMultiCurrency ? '1' : '0')
          formData.append('dollar_rate', this.incomeInfo.dollar_rate)
          formData.append('income_type_id_fk', this.incomeInfo.income_type_id_fk || '')
          formData.append('amount', this.incomeInfo.amount)
          if (this.imageData != null) {
            formData.append('attachment', this.imageFile[0])
          }

          let payload = { id: this.incomeInfo.income_id, formData }
          this.updateIncomeInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
